import React from "react";
import { HeaderComponent } from "./header.component";
import { MenuComponent } from "./menu.component";
import { ContentComponent } from "./content.component";
import { ErrorHandlerComponent } from "../error_handling/error_handler.component";
import { FooterComponent } from "./footer.component";
import { useTranslation } from "react-i18next";
import { addConfigurationStateTexts } from "models/configuration_state.enum";
import { Outlet } from "react-router";
import { Container } from "@mui/material";
import { BreadcrumbArea } from "shared/breadcrumbs/breadcrumbs_root.style";
import { BreadcrumbsComponent } from "shared/breadcrumbs/components/breadcrumbs";
import { LayoutAreaRoot } from "./layoutarea.style";

export const LayoutArea = () => {
  const { t } = useTranslation();
  addConfigurationStateTexts(t);

  return (
    <LayoutAreaRoot>
      <HeaderComponent />
      <MenuComponent />
      <BreadcrumbArea>
        <Container>
          <BreadcrumbsComponent />
        </Container>
      </BreadcrumbArea>
      <ContentComponent>
        <ErrorHandlerComponent>
          <Outlet />
        </ErrorHandlerComponent>
      </ContentComponent>
      <FooterComponent />
    </LayoutAreaRoot>
  );
};
